module.exports = __webpack_public_path__ + "static/media/replayer_logo_neg.2c01f5a2.svg";